import { useState } from 'react';
import FolderApresentacao from '@/pages/folder/components/FolderApresentacao';
import FolderTributario from '@/pages/folder/components/FolderTributario';
import FolderIRPF from '@/pages/folder/components/FolderIRPF';
import FolderDiagnostico from '@/pages/folder/components/FolderDiagnostico';

const modelos = [
  {
    id: 1,
    titulo: 'Apresentação Geral',
    descricao: 'Apresenta a RCP com todos os serviços — ideal para novos contatos.',
    tag: 'Azul Escuro',
    tagColor: 'bg-[#0f2651] text-white',
    component: <FolderApresentacao />,
  },
  {
    id: 2,
    titulo: 'Planejamento Tributário',
    descricao: 'Foco em redução de impostos e estratégia fiscal — ótimo para empresas.',
    tag: 'Claro & Dourado',
    tagColor: 'bg-[#c9a84c]/15 text-[#a07a28]',
    component: <FolderTributario />,
  },
  {
    id: 3,
    titulo: 'Declaração de IRPF',
    descricao: 'Tema imposto de renda — perfeito para divulgar na época do IR.',
    tag: 'Marrom Premium',
    tagColor: 'bg-amber-900/10 text-amber-800',
    component: <FolderIRPF />,
  },
  {
    id: 4,
    titulo: 'Diagnóstico Gratuito',
    descricao: 'CTA direto para o WhatsApp — ideal para captar novos clientes.',
    tag: 'Branco & Navy',
    tagColor: 'bg-gray-100 text-gray-600',
    component: <FolderDiagnostico />,
  },
];

export default function FolderPage() {
  const [ativo, setAtivo] = useState(0);
  const modelo = modelos[ativo];

  return (
    <div className="min-h-screen bg-[#f0ece4]">
      {/* Top bar */}
      <div className="bg-[#0f2651] border-b border-[#c9a84c]/20 px-6 py-4">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <div>
            <span className="text-white font-bold text-base" style={{ fontFamily: 'Georgia, serif' }}>RCP</span>
            <span className="text-[#c9a84c] text-xs ml-2 font-medium">Folders para Divulgação</span>
          </div>
          <a
            href="/"
            className="text-white/50 hover:text-white text-xs flex items-center gap-1.5 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Voltar ao site
          </a>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-10">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-[#0f2651] font-bold text-2xl mb-2" style={{ fontFamily: 'Georgia, serif' }}>
            Modelos de Folder
          </h1>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            Escolha um modelo, tire um print e compartilhe no Instagram Stories ou WhatsApp.
          </p>
        </div>

        {/* Model selector tabs */}
        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {modelos.map((m, i) => (
            <button
              key={m.id}
              onClick={() => setAtivo(i)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-lg border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                ativo === i
                  ? 'bg-[#0f2651] border-[#0f2651] text-white'
                  : 'bg-white border-gray-200 text-gray-600 hover:border-[#0f2651]/30 hover:text-[#0f2651]'
              }`}
            >
              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${ativo === i ? 'bg-white/20 text-white' : m.tagColor}`}>
                {m.id}
              </span>
              {m.titulo}
            </button>
          ))}
        </div>

        {/* Main content */}
        <div className="flex flex-col lg:flex-row gap-8 items-start justify-center">
          {/* Folder preview */}
          <div className="flex flex-col items-center">
            <div className="mb-3 flex items-center gap-2">
              <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${modelo.tagColor}`}>
                {modelo.tag}
              </span>
              <span className="text-gray-400 text-xs">Story 9:16</span>
            </div>

            {/* Folder card with subtle frame */}
            <div className="rounded-2xl overflow-hidden" style={{ boxShadow: '0 4px 32px rgba(15,38,81,0.15)' }}>
              {modelo.component}
            </div>

            {/* Navigation arrows */}
            <div className="flex items-center gap-4 mt-5">
              <button
                onClick={() => setAtivo((prev) => (prev - 1 + modelos.length) % modelos.length)}
                className="w-9 h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full hover:border-[#0f2651] hover:text-[#0f2651] text-gray-400 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-lg" />
              </button>
              <span className="text-gray-400 text-xs">{ativo + 1} / {modelos.length}</span>
              <button
                onClick={() => setAtivo((prev) => (prev + 1) % modelos.length)}
                className="w-9 h-9 flex items-center justify-center bg-white border border-gray-200 rounded-full hover:border-[#0f2651] hover:text-[#0f2651] text-gray-400 transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-lg" />
              </button>
            </div>
          </div>

          {/* Info panel */}
          <div className="lg:w-72 flex flex-col gap-4">
            {/* Model info */}
            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <div className={`inline-flex text-xs px-2.5 py-1 rounded-full font-semibold mb-3 ${modelo.tagColor}`}>
                Modelo {modelo.id}
              </div>
              <h2 className="text-[#0f2651] font-bold text-base mb-1">{modelo.titulo}</h2>
              <p className="text-gray-500 text-sm leading-relaxed">{modelo.descricao}</p>
            </div>

            {/* How to use */}
            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <h3 className="text-[#0f2651] font-bold text-sm mb-3 flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center text-[#c9a84c]">
                  <i className="ri-lightbulb-line" />
                </div>
                Como usar
              </h3>
              <ul className="space-y-2.5">
                {[
                  { icon: 'ri-screenshot-line', text: 'Tire um print da tela (celular ou PC)' },
                  { icon: 'ri-crop-line', text: 'Recorte apenas o folder se necessário' },
                  { icon: 'ri-instagram-line', text: 'Poste como Story no Instagram' },
                  { icon: 'ri-whatsapp-line', text: 'Envie pelo WhatsApp ou status' },
                ].map((tip) => (
                  <li key={tip.text} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex items-center justify-center text-[#c9a84c] flex-shrink-0 mt-0.5">
                      <i className={`${tip.icon} text-sm`} />
                    </div>
                    <span className="text-gray-500 text-xs leading-relaxed">{tip.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* All models quick nav */}
            <div className="bg-white rounded-xl border border-gray-100 p-5">
              <h3 className="text-[#0f2651] font-bold text-sm mb-3">Todos os modelos</h3>
              <div className="space-y-2">
                {modelos.map((m, i) => (
                  <button
                    key={m.id}
                    onClick={() => setAtivo(i)}
                    className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-all cursor-pointer ${
                      ativo === i ? 'bg-[#0f2651]/5 border border-[#0f2651]/15' : 'hover:bg-gray-50 border border-transparent'
                    }`}
                  >
                    <span className={`w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold flex-shrink-0 ${
                      ativo === i ? 'bg-[#0f2651] text-white' : 'bg-gray-100 text-gray-500'
                    }`}>
                      {m.id}
                    </span>
                    <div>
                      <div className={`text-xs font-semibold ${ativo === i ? 'text-[#0f2651]' : 'text-gray-600'}`}>{m.titulo}</div>
                      <div className={`text-[10px] ${m.tagColor} inline-flex px-1.5 py-0.5 rounded-full mt-0.5`}>{m.tag}</div>
                    </div>
                    {ativo === i && (
                      <div className="ml-auto w-4 h-4 flex items-center justify-center text-[#c9a84c]">
                        <i className="ri-eye-line text-xs" />
                      </div>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/5551991003410"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#0f2651] hover:bg-[#1a3a6e] text-white font-semibold text-sm py-3 rounded-xl transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line" />
              </div>
              Falar com a RCP no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
